<template>
  <div :class="`wrapper-full ${border1}`" @click="select" :style="`height:${dispH}px;`">
    <div class="img-item" :style="`height:${dispH - 30}px;`">
      <img alt="" :src="photo" style="width: auto; height: 100%; max-height: 100%" />
    </div>
    <div
      class="img-name"
      :style="`background:${namebackground};color:${namecolor};${imagenameStyle}`"
    >
      {{ imagename }}
    </div>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../../mixins";
import { getImageUrl } from "../../../shared/utils";
// import { token } from '../../../services/session_token'
let img1px = new Image();
img1px.onload = () => {};
export default {
  name: "ImageItem",
  data() {
    return {
      photo: {}
    };
  },
  props: {
    selected: true,
    id: {
      type: String | Number,
      default: -1
    },
    currentid: {
      type: String | Number,
      default: -1
    },
    thumbnail: {
      type: String,
      default: ""
    },
    imagename: {
      type: String,
      default: ""
    },
    namebackground: {
      type: String,
      default: "#333333"
    },
    namecolor: {
      type: String,
      default: "white"
    },
    src: {
      type: String,
      default: ""
    },
    dispH: {
      type: Number,
      default: 240
    },
    imagenameStyle: {
      type: String,
      default: ""
    },
    photos: {
      type: Array
    }
  },
  mixins: [Size, SubPageSize],
  mounted() {
    this.$nextTick(() => {
      // 脂质层
      if (this.src) {
        this.photo = this.src;
      } else {
        this.photo = this.getImageURL(this.thumbnail);
      }
    });
  },
  methods: {
    select() {
      this.$emit("select", this.id);
    },
    getImageURL: function (filename) {
      return getImageUrl(filename, window.server, window.token);
    }
  },
  computed: {
    border1() {
      if (this.photos && this.photos.length === 6) {
        let sign = this.photos[this.currentid] ? this.currentid : this.currentid < 3 ? 3 : 0;
        return this.currentid >= 0 && (this.id === this.currentid || this.id === sign)
          ? "img-border-green"
          : "img-border-gray";
      } else {
        return this.currentid >= 0 && this.id === this.currentid
          ? "img-border-green"
          : "img-border-gray";
      }
    }
  },
  watch: {
    thumbnail(newValue, oldValue) {
      if (this.thumbnail) {
        this.photo = this.getImageURL(this.thumbnail);
      } else {
        this.photo = "";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.img-border-green {
  border: solid 1px #00ff00;
}
.img-border-gray {
  border: solid 1px gray;
}
.img-container {
  display: flex;
  flex-direction: column;
}
.img-name {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333333;
}
.img-item {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  user-select: none;
  -webkit-user-drag: none;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/basic/ImageItem.vue